import { Controller } from "stimulus";
import { get, set } from "./idb";

export default class extends Controller {
  static targets = ["input", "submit", "status"];
  activeUploads = 0;
  storedFiles = [];

  removeUploadedFolder = async (event) => {
    if (event) event.preventDefault();
    const button = event && event.currentTarget;
    const parentFolder = await get("cmac_folder");
    const openFolder = await get("open_folder");
    if (!parentFolder || !openFolder || !openFolder.name) {
      this.setStatus(
        "This browser no longer has the CMAC folder. Delete that case folder on the device, then eject it."
      );
      return;
    }

    const permission = await parentFolder.requestPermission({ mode: "readwrite" });
    if (permission !== "granted") {
      this.setStatus("The folder is still on the CMAC. Allow access to remove it.");
      return;
    }

    await parentFolder.removeEntry(openFolder.name, { recursive: true });
    this.setStatus("That folder has been removed from the CMAC. Eject the device, then log out.");
    if (button) button.disabled = true;
  };

  getusb = async () => {
    let patient_number_field = document.getElementById(
      "intubation_review_patient_number"
    );
    const patientNumber = patient_number_field ? patient_number_field.value.trim() : "";
    if (!/^\d{6}$/.test(patientNumber)) {
      this.setStatus("Enter the 6-digit patient number before opening the CMAC.");
      if (patient_number_field) patient_number_field.focus();
      return;
    }
    dirHandle = await window.showDirectoryPicker();
    const permissionStatus = await dirHandle.queryPermission({
      mode: "readwrite",
    });

    if (permissionStatus === "prompt") {
      // Display a message to the user explaining that they will need to grant permission
      alert(
        "You will need to grant permission for this app to modify files in the selected directory."
      );
      // Now perform an action that requires permission to trigger the permission prompt
      await dirHandle.removeEntry("dummy", { recursive: true }).catch(() => {});
    }

    console.log("***DIR HANDLE NEW- really new***", dirHandle);
    if (dirHandle.name.match(/C-MAC/) || dirHandle.name === "\\") {
      this.createList(dirHandle);
      await set("cmac_folder", dirHandle);
    } else {
      alert("Please select the plugged in C-MAC device named 'C-MAC PM'");
    }
  };

  selected = async (e) => {
    if (e.target.closest("li").dataset.handle.split(".").pop() !== "avi") {
      console.log("SELECTED", e.target.dataset.handle);
      const directoryHandle = await get(e.target.closest("li").dataset.handle);
      this.createList(directoryHandle);
    } else {
      this.uploadFile(e);
    }
  };

  submitForm = (event) => {
    if (event) event.preventDefault();
    if (this.activeUploads > 0 || this.storedFiles.length === 0) {
      this.setStatus(
        "Wait until at least one video says Uploaded. The case is not saved yet, and the CMAC folder is unchanged."
      );
      return;
    }

    const patientNumberField = document.getElementById(
      "intubation_review_patient_number"
    );
    const patientNumber = patientNumberField ? patientNumberField.value.trim() : "";
    if (!/^\d{6}$/.test(patientNumber)) {
      this.setStatus("Enter the 6-digit patient number before submitting.");
      return;
    }

    document.getElementById("new_intubation_review").submit();
  };

  refreshSubmit() {
    if (!this.hasSubmitTarget) return;

    const ready = this.storedFiles.length > 0 && this.activeUploads === 0;
    this.submitTarget.disabled = !ready;
    this.submitTarget.classList.toggle("disabled", !ready);
    if (!ready) return;

    const count = this.storedFiles.length;
    const label = count === 1 ? "video is" : "videos are";
    this.setStatus(
      `${count} ${label} stored. Submit saves the case. The folder stays on the CMAC until the next screen.`
    );
  }

  setStatus(message) {
    if (!this.hasStatusTarget) return;

    this.statusTarget.hidden = false;
    this.statusTarget.textContent = message;
  }

  createList = async (directoryHandle) => {
    let file_list = document.getElementById("file-list");
    let page_1 = document
      .getElementById("upload-screen-1")
      .classList.add("hidden");
    let page_2 = document
      .getElementById("upload-screen-2")
      .classList.remove("hidden");
    file_list.innerHTML = "";
    this.setOpen(directoryHandle);
    for await (const [key, value] of directoryHandle.entries()) {
      if (key[0] !== "." && key !== "System Volume Information") {
        console.log({ key, value });

        let li = document.createElement("li");
        li.dataset.handle = key;
        li.dataset.action = "click->usb#selected";
        li.className =
          key.split(".").pop() === "avi" || value.kind == "directory"
            ? "list-group-item vid-link"
            : "list-group-item text-muted";
        let row = document.createElement("div");
        let col_1 = document.createElement("div");
        col_1.className = "col";
        let col_2 = document.createElement("div");
        col_2.className = "col align-self-end";
        row.className = "row";
        let text = document.createTextNode(` ${key}`);
        let icon = this.getIcon(key, value);
        let btn = this.getButton(key);

        col_1.appendChild(icon);
        col_1.appendChild(text);
        row.appendChild(col_1);
        row.appendChild(col_2);
        li.appendChild(row);
        if (btn) {
          col_2.appendChild(btn);
        }
        file_list.appendChild(li);
        await set(key, value);
        // if (key.includes(".avi")) {
        //   let file = await value.getFile();
        //   console.log("VIDEO FILE", file);
        //   dirHandle.removeEntry(key);
        // }
      }
      document.getElementById("open-picker-button").style.display = "none";
      document.getElementById("open-folder").style.display = "";

      //document.getElementById("directions").innerHTML =
      //"Navigate to the folder that contains your video file(s) and click on them to upload.";
    }
  };

  setOpen = async (directoryHandle) => {
    let open = await get("open_folder");
    await set("previous_folder", open);
    console.log("DH", directoryHandle);
    await set("open_folder", directoryHandle);
    let back_el = document.getElementById("open-folder");
    let icon = document.createElement("i");
    icon.className = "fa fa-folder-open";
    let text = document.createTextNode(` ${directoryHandle.name}`);
    back_el.innerHTML = "";
    back_el.appendChild(icon);
    back_el.appendChild(text);
  };

  goBack = async () => {
    let directoryHandle = await get("previous_folder");
    await this.createList(directoryHandle);
  };

  getButton = (key) => {
    if (key.split(".").pop() === "avi") {
      let upload_button = document.createElement("div");
      upload_button.className = "btn btn-sm btn-primary";
      let btn_text = document.createTextNode("CLICK TO UPLOAD");
      upload_button.appendChild(btn_text);
      return upload_button;
    }
  };

  getIcon = (key, value) => {
    let icon = document.createElement("i");
    if (value.kind === "directory") {
      icon.className = "fa fa-folder";
    } else if (key.split(".").pop() === "avi") {
      icon.className = "fa fa-film";
    } else {
      icon.className = "fa fa-file";
    }
    return icon;
  };

uploadFile = async (e) => {
  const row = e.target.closest("li");
  if (!row || row.dataset.uploading === "true" || row.dataset.stored === "true") return;

  const associationField = document.getElementsByClassName("video-association-id")[0];
  const videoAssociationId = associationField && associationField.value;
  if (!videoAssociationId) {
    this.setStatus("This page is missing an upload id. Reload it and start again.");
    return;
  }

  this.activeUploads += 1;
  row.dataset.uploading = "true";
  row.dataset.action = "";
  this.refreshSubmit();

  const uploadButton = row.getElementsByClassName("btn")[0];
  if (uploadButton) uploadButton.classList.add("hidden");
  row.querySelectorAll(".cmac-upload-progress").forEach((bar) => bar.remove());
  const progress = this.progressBar(row);
  const fileHandle = await get(row.dataset.handle);
  const file = await fileHandle.getFile();
  const reviewId = this.hasInputTarget
    ? this.inputTarget.getAttribute("data-review-id")
    : "";

  try {
    const stored = file.size <= 5 * 1024 * 1024
      ? Boolean(await this.directUpload(file, videoAssociationId, reviewId))
      : await this.multipartUpload(file, videoAssociationId, reviewId, progress);

    if (!stored) throw new Error(`Upload failed for ${file.name}`);

    progress.style.width = "100%";
    row.dataset.stored = "true";
    row.classList.add("cmac-file-stored");
    row.classList.remove("cmac-file-failed");
    this.setRowLabel(row, "Uploaded");
    this.storedFiles.push(file.name);
  } catch (error) {
    console.error(error);
    row.dataset.uploading = "";
    row.dataset.action = "click->usb#selected";
    row.classList.add("cmac-file-failed");
    if (uploadButton) {
      uploadButton.classList.remove("hidden");
      uploadButton.textContent = "TRY AGAIN";
    }
    this.setRowLabel(row, "Not uploaded");
    this.setStatus(
      `${file.name} did not upload. It is still on the CMAC. Click it to try again.`
    );
  } finally {
    this.activeUploads = Math.max(0, this.activeUploads - 1);
    this.refreshSubmit();
  }
};

multipartUpload = async (file, videoAssociationId, reviewId, progress) => {
  const filename = file.name;
  const uploadId = await this.initiateMultipartUpload(
    videoAssociationId,
    reviewId,
    filename
  );
  if (!uploadId) return false;

  const chunkSize = 5 * 1024 * 1024;
  const totalChunks = Math.ceil(file.size / chunkSize);
  const uploadedParts = [];

  for (let index = 0; index < totalChunks; index++) {
    const start = index * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const part = await this.uploadPartWithRetry(
      file.slice(start, end),
      index + 1,
      videoAssociationId,
      uploadId,
      filename
    );
    if (!part || !part.etag) return false;

    uploadedParts.push({ etag: part.etag, part_number: index + 1 });
    progress.style.width = `${((index + 1) / totalChunks) * 100}%`;
  }

  return this.completeMultipartUpload(
    videoAssociationId,
    reviewId,
    uploadId,
    uploadedParts,
    filename
  );
};

progressBar(row) {
  const bar = document.createElement("div");
  bar.className = "cmac-upload-progress";
  const indicator = document.createElement("span");
  bar.appendChild(indicator);
  row.appendChild(bar);
  return indicator;
}

setRowLabel(row, label) {
  let status = row.querySelector(".cmac-file-label");
  if (!status) {
    status = document.createElement("span");
    status.className = "cmac-file-label";
    row.appendChild(status);
  }
  status.textContent = label;
}

directUpload = async (file, video_association_id, review_id) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('videoAssociationId', video_association_id);
  formData.append('reviewId', review_id);
  formData.append('filename', file.name);

  const response = await fetch('/uploads/direct_upload', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    console.error("Direct upload failed:", await response.text());
    return null;
  }

  const data = await response.json();
  console.log("Direct upload completed with response: ", data);
  return data;
};

uploadPartWithRetry = async (chunk, partNumber, videoAssociationId, uploadId, filename) => {
  let lastPart = { etag: null };
  for (let attempt = 1; attempt <= 3; attempt++) {
    try {
      lastPart = await this.uploadPart(
        chunk,
        partNumber,
        videoAssociationId,
        uploadId,
        filename
      );
      if (lastPart && lastPart.etag) return lastPart;
    } catch (error) {
      console.error(error);
    }
    await new Promise((resolve) => setTimeout(resolve, attempt * 1000));
  }
  return lastPart;
};

initiateMultipartUpload = async (video_association_id, review_id, filename) => {
  const response = await fetch('/uploads/initiate_multipart_upload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...this.csrfHeaders(),
    },
    body: JSON.stringify({ video_association_id, review_id, filename }),
  });

  if (!response.ok) {
    console.error("Failed to initiate multipart upload:", await response.text());
    return null;
  }

  const data = await response.json();
  console.log("Initiated upload ID: ", data.uploadId); // Verify the upload ID
  return data.uploadId;
};

uploadPart = async (chunk, partNumber, video_association_id, uploadId, filename) => {
  const formData = new FormData();
  formData.append('chunk', chunk);
  formData.append('partNumber', partNumber);
  formData.append('videoAssociationId', video_association_id);
  formData.append('uploadId', uploadId);
  formData.append('filename', filename);

  console.log(`Uploading part ${partNumber} with upload ID: ${uploadId}`); // Log the part upload

  const response = await fetch('/uploads/upload_part', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    console.error(`Failed to upload part ${partNumber}:`, await response.text());
    return { etag: null };
  }

  const data = await response.json();
  return data;
};

completeMultipartUpload = async (video_association_id, review_id, uploadId, uploadedParts, filename) => {
  for (let attempt = 1; attempt <= 3; attempt++) {
    const response = await fetch('/uploads/complete_multipart_upload', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.csrfHeaders(),
      },
      body: JSON.stringify({
        video_association_id,
        review_id,
        uploadId,
        filename,
        parts: uploadedParts,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data.status === 'completed';
    }

    console.error("Failed to complete multipart upload:", await response.text());
    await new Promise((resolve) => setTimeout(resolve, attempt * 1000));
  }

  return false;
};

csrfHeaders() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  if (!meta) return {};

  return { "X-CSRF-Token": meta.content };
}

  get url() {
    return this.inputTarget.getAttribute("data-direct-upload-url");
  }
  // const filters = [{}];
  // navigator.usb.requestDevice({ filters: filters }).then((devices) => {
  //   console.log("DEVICES", devices);
  // });
}


async function sendChunk(
  chunk,
  index,
  totalChunks,
  file,
  progressCallback,
  review_id,
  uuid,
  video_association_id
) {
  console.log("SENDING CHUNK VIDO ASS UUID", video_association_id);
  const formData = new FormData();
  formData.append("chunk", new Blob([chunk]), "chunk");
  formData.append("index", index);
  formData.append("totalChunks", totalChunks);
  formData.append("fileName", file.name);
  formData.append("reviewId", review_id);
  formData.append("uuid", uuid);
  formData.append("videoAssociationId", video_association_id);
  const response = await fetch("/uploads", {
    method: "POST",
    body: formData,
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
    },
  });
  console.log("RESPONSE", response);
  if (!response.ok) {
    console.log("NOT OK");
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  // parse the JSON response body
  let data = {};
  try {
    data = await response.json();
    console.log("DATA", data);
    setVideoUuid(data.key);
  } catch (error) {
    console.error("Error parsing response as JSON:", error);
  }
  // Update the progress
  progressCallback(chunk.byteLength);
}
function generateUUID() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
function setVideoUuid(uuid) {
  let video_uuid = document.getElementsByClassName("video-uuid")[0];
  
  if (video_uuid.value === "") {
    video_uuid.value = uuid;
  } else {
    video_uuid.value += "|" + uuid;
  }
}

function uploadComplete() {
  //alert("Upload complete!");
}
function readFileInChunks(file, progressCallback, completeCallback, review_id, video_association_id) {
  const chunkSize = 1024 * 1024 * 100; // 4MB
  const pieceSize = 1024 * 1024; // 1MB
  let offset = 0;
  let index = 0;
  let totalUploaded = 0;
  const totalChunks = Math.ceil(file.size / pieceSize);
  const uuid = generateUUID();
  console.log("VIDEO ASSOCIATION ID", video_association_id);
  function readChunk() {
    const reader = new FileReader();
    const blob = file.slice(offset, offset + chunkSize);
    reader.onload = (event) => {
      // Divide the chunk into pieces
      let chunkOffset = 0;
      function sendPiece() {
        console.log(
          "offset is",
          chunkOffset,
          "file size is",
          event.target.result.byteLength
        );
        if (chunkOffset < event.target.result.byteLength) {
          const piece = event.target.result.slice(
            chunkOffset,
            chunkOffset + pieceSize
          );
          sendChunk(
            piece,
            index,
            totalChunks,
            file,
            (uploaded) => {
              totalUploaded += uploaded;
              progressCallback(totalUploaded / file.size);
              chunkOffset += pieceSize;
              index += 1;
              sendPiece();
            },
            review_id,
            uuid,
            video_association_id
          );
        } else {
          // All pieces of this chunk have been sent
          console.log(
            "final offset is",
            offset,
            "final file size is",
            file.size
          );
          offset += chunkSize;
          if (offset < file.size) {
            readChunk();
          } else {
            completeCallback();
          }
        }
      }
      sendPiece();
    };
    reader.readAsArrayBuffer(blob);
  }

  readChunk();
}

let dirHandle = null;
